import { PRESENTATIONS_STATIC_PATH_V2 } from "@/api/staticPaths";

export const ITEMS = [
    {
        src: `${PRESENTATIONS_STATIC_PATH_V2}addFirstSlide1.png`,
        text: "Нажмите на значок презентации \n" + "в основной панели инструментов",
    },
    {
        src: `${PRESENTATIONS_STATIC_PATH_V2}addFirstSlide2.png`,
        text:
            "или выделите один или несколько \n" +
            "фреймов и нажмите «создать \n" +
            " презентацию» в контекстном меню",
    },
];
